export const ChargeByStatusModeEnum = {
  BillingAccount: -3,
  NotValidMealStatus: -2,
  ChargeSetToN: -1,
  NoLimit: 0,
  MaxChargeAmount: 1,
  MaxChargeCount: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ChargeByStatusModeEnum.js